module.exports = __webpack_public_path__ + "img/D001_R_home slider.cffc45a0.jpg";